import React, { useEffect, useState } from 'react';
import styles from './StationInfo.module.css';
import carStatusOn from "../../../../img/carStatusOn.svg";
import carStatusOff from "../../../../img/carStatusOff.svg";
import localeRu from '../../../../locales/ru/stations/stationControl.json';
import localeEn from '../../../../locales/en/stations/stationControl.json';

const StationInfo = ({status, parameter}) => {
    let lang = localStorage.getItem('language') === 'ru';

    return (
            <div className={styles.sectionHeader}>
                {status === "Available" || status == null ? (
                    <div className={styles.sectionTitle}>
                        <img
                            src={carStatusOff}
                            className={styles.logo}
                            alt='carOff' />
                        <p className={styles.titleTextN}>{lang ? localeRu.disconnectCar : localeEn.disconnectCar}</p>
                    </div>
                ) : (
                    <div className={styles.sectionTitle}>
                        <img
                            src={carStatusOn}
                            className={styles.logo}
                            alt='carOn' />
                        <p className={styles.titleTextN}>{lang ? localeRu.connectCar : localeEn.connectCar}</p>
                    </div>
                )
                }
                <p className={styles.modelText}>{parameter}</p>
            </div>
    )
}

export default StationInfo;